import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useSendTestEmail, type TestEmailResult } from "@/hooks/use-fulfillment";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function TestEmailSection() {
  const [email, setEmail] = useState("");
  const [diag, setDiag] = useState<TestEmailResult | null>(null);
  const sendTest = useSendTestEmail();

  async function handleSend() {
    const to = email.trim();
    if (!to) {
      toast.error("Unesite email adresu");
      return;
    }
    setDiag(null);
    try {
      const r = await sendTest.mutateAsync(to);
      setDiag(r);
      if (r.ok) {
        toast.success("Test email poslan");
      } else {
        toast.error(r.hint || r.error || "Greška pri slanju test email-a");
      }
    } catch (e: any) {
      toast.error(e.message || "Greška pri slanju test email-a");
    }
  }

  return (
    <div className="ring-1 ring-foreground/10">
      <div className="border-b bg-muted/50 px-4 py-2">
        <span className="text-xs font-medium">Test email (SMTP)</span>
      </div>
      <div className="p-4 flex flex-col gap-3 max-w-lg">
        <p className="text-xs text-muted-foreground">
          Pošalji test email da provjeriš SMTP konfiguraciju iz .env.
        </p>
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="test-email" className="text-xs">Email adresa</Label>
          <Input
            id="test-email"
            type="email"
            placeholder="vas@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <Button
          type="button"
          className="self-start"
          onClick={handleSend}
          disabled={sendTest.isPending || !email.trim()}
        >
          {sendTest.isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Pošalji test
        </Button>

        {diag && (
          <div
            className={`flex flex-col gap-1.5 rounded border p-3 text-xs ${
              diag.ok
                ? "border-green-600/30 bg-green-600/5"
                : "border-red-600/30 bg-red-600/5"
            }`}
          >
            <span className="font-medium">
              {diag.ok ? "Uspješno poslano" : `Neuspjelo (HTTP ${diag.status})`}
            </span>
            {!diag.ok && diag.error && (
              <div className="text-red-400 whitespace-pre-wrap">{diag.error}</div>
            )}
            {diag.hint && (
              <div className="text-amber-500 whitespace-pre-wrap">Savjet: {diag.hint}</div>
            )}
            <pre className="mt-1 max-h-64 overflow-auto rounded bg-muted/50 p-2 text-[11px] leading-relaxed">
              {JSON.stringify(
                { config: diag.config, detail: diag.detail },
                null,
                2,
              )}
            </pre>
          </div>
        )}
      </div>
    </div>
  );
}
